module.exports = __webpack_public_path__ + "img/current-badge-pitch.6e555e14.svg";